export default "__VITE_ASSET__hNQcVcdQ__"